import React from "react";
import sort from "../../images/sort.svg";
import add from "../../images/add.svg";
import share from "../../images/share.svg";
import { NavLink } from "react-router-dom";
import { useToast } from "../../lib";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";

function TipsterFunction({ onClick }) {
  const toast = useToast();
  const [user] = useRecoilState(auth_user);

  return (
    <div className="container">
      <div className="row">
        <div className="col-xxl">
          <button
            onClick={() => onClick && onClick()}
            className="filter flex justify-center w-fit lg:w-[17%] items-center gap-2"
          >
            {" "}
            <img src={sort} className="img-fluid sort" alt="sort" />
            Filter
          </button>
          <div className="flex w-full justify-end gap-3">
            <NavLink to="/post">
              <button className="bg-white h-[54px] w-[200px] rounded-full texts text-sm flex justify-center items-center gap-2">
                <img src={add} className="img-fluid sort" alt="add" />
                Post Booking Code
              </button>
            </NavLink>
            <button
              onClick={() => {
                navigator.clipboard
                  .writeText(
                    `${window.location.origin}/mybets?username=${user?.username}&externalId=${user?.externalId}`
                  )
                  .then(() => {
                    toast({
                      type: "success",
                      message: "URL Copied to clipboard",
                    });
                  });
              }}
              className=" bg-white h-[54px] w-[200px] texts text-sm rounded-full flex justify-center items-center gap-2"
            >
              <img src={share} className="img-fluid sort" alt="add" />
              Share URL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TipsterFunction;
